import { code } from "@spscommerce/utils";

export const SpsProgressBarExamples = {
    basic: {
        label: "Basic",
        description: "basic progress bar",
        examples: {
            basic: {
                jsx: code`
                    <SpsCard>
                        <SpsProgressBar percentComplete={0.33}/>
                    </SpsCard>
                `
            },
            complete: {
                jsx: code`
                    <SpsCard>
                        <SpsProgressBar percentComplete={1}/>
                    </SpsCard>
                `
            },
            withTitle: {
                jsx: code`
                    <SpsCard>
                        <SpsProgressBar title="filename.csv" percentComplete={0.47}/>
                    </SpsCard>
                `
            },
            withDetail: {
                jsx: code`
                    <SpsCard>
                        <SpsProgressBar title="filename.csv" detail="Verifying headers..." percentComplete={2/3}/>
                    </SpsCard>
                `
            },
            closeable: {
                react: code`
                    function Component() {
                        function handleClose() {
                            console.log("closed")
                        }

                        return <SpsCard>
                            <SpsProgressBar title="filename.csv"
                                detail="Verifying headers..."
                                percentComplete={0.87}
                                onClose={handleClose}
                            />
                        </SpsCard>
                    }
                `
            },
        },
    },
};
